import React from "react";
import {
  SimpleShowLayout,
  TextField,
  NumberInput,
  TextInput
} from "react-admin";

const FormTab = (props) => {
  return (
    <SimpleShowLayout {...props}>
      <TextField source="girlsvolleyball.id" />
      <NumberInput source="girlsvolleyball.seasonWins" />
      <NumberInput source="girlsvolleyball.seasonLosses" />
      <NumberInput source="girlsvolleyball.seasonTies" />
      <NumberInput source="girlsvolleyball.seasonPercentWins" />
      <NumberInput source="girlsvolleyball.districtWins" />
      <NumberInput source="girlsvolleyball.districtLosses" />
      <NumberInput source="girlsvolleyball.districtTies" />
      <NumberInput source="girlsvolleyball.districtPercentWins" />
      <NumberInput source="girlsvolleyball.homeWins" />
      <NumberInput source="girlsvolleyball.homeLosses" />
      <NumberInput source="girlsvolleyball.homeTies" />
      <NumberInput source="girlsvolleyball.roadWins" />
      <NumberInput source="girlsvolleyball.roadLosses" />
      <NumberInput source="girlsvolleyball.roadTies" />
      <TextInput source="girlsvolleyball.streak" />
      <NumberInput source="girlsvolleyball.differential" />
    </SimpleShowLayout>
  );
};

export default FormTab;
